
export default function transaction (name) {
  return {
    methods: {
      resetTransaction () {
        if (this.$store) {
          this.$store.dispatch('Transaction/resetTransactionId', name)
        }
      }
    },
    beforeCreate () {
      if (this.$store) {
        this.$store.dispatch('Transaction/createTransactionId', name)
      }
    }
  }
}
